import { Money } from './Money';
import { cn } from '@repo/utils';
import { DEFAULT_CURRENCY, DEFAULT_LOCALE } from '../../lib/locale';

interface LedgerEntry {
  id: string;
  date: string;
  description: string;
  debitPaise?: number;
  creditPaise?: number;
  balancePaise: number;
}

interface LedgerProps {
  entries: LedgerEntry[];
  currency?: string;
  locale?: string;
  className?: string;
}

export function Ledger({
  entries,
  currency = DEFAULT_CURRENCY,
  locale = DEFAULT_LOCALE,
  className,
}: LedgerProps) {
  return (
    <div className={cn('w-full overflow-x-auto rounded-md border border-border', className)}>
      <table className="w-full text-sm">
        <thead className="bg-surface-2 text-text-secondary">
          <tr>
            <th className="px-4 py-2 text-left font-medium sticky left-0 z-sticky bg-surface-2">Date</th>
            <th className="px-4 py-2 text-left font-medium">Description</th>
            <th className="px-4 py-2 text-right font-medium">Debit</th>
            <th className="px-4 py-2 text-right font-medium">Credit</th>
            <th className="px-4 py-2 text-right font-medium">Balance</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {entries.length === 0 ? (
            <tr>
              <td colSpan={5} className="px-4 py-8 text-center text-text-muted">
                No ledger entries found.
              </td>
            </tr>
          ) : (
            entries.map((entry) => (
              <tr key={entry.id} className="hover:bg-surface-2 transition-colors group">
                <td className="px-4 py-3 text-text-primary whitespace-nowrap sticky left-0 z-sticky bg-surface-1 group-hover:bg-surface-2 transition-colors">
                  {new Date(entry.date).toLocaleDateString(locale)}
                </td>
                <td className="px-4 py-3 text-text-primary">{entry.description}</td>
                <td className="px-4 py-3 text-right">
                  {entry.debitPaise !== undefined && (
                    <Money paise={entry.debitPaise} currency={currency} locale={locale} />
                  )}
                </td>
                <td className="px-4 py-3 text-right">
                  {entry.creditPaise !== undefined && (
                    <Money paise={entry.creditPaise} currency={currency} locale={locale} />
                  )}
                </td>
                <td className="px-4 py-3 text-right font-medium">
                  <Money paise={entry.balancePaise} currency={currency} locale={locale} />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
